import Loader from '@shared/components/Loader';
import { DASHBOARD_TABLE_CONFIG } from '../../entity';
import { useVisitsListOpen } from './visits-list-open.hooks';
import VisitsListTable from './visits-list-table';

const VisitsListOpen = () => {
  const { rows, columns, isLoading, visits } = useVisitsListOpen();

  if (isLoading || !visits) {
    return <Loader />;
  }

  return (
    <VisitsListTable
      rows={rows}
      columns={columns}
      {...DASHBOARD_TABLE_CONFIG}
      visitListApplyFilter="onlyOpenVisits"
    />
  );
};

export default VisitsListOpen;
